export default {
  sizes: ["Бит", "КБ", "МБ", "ГБ", "ТБ", "ПБ"],
  uploadNoMoreFiles: "Бештар аз {maxFileCount} файл бор карда нашавад",
  maxFileSize: {
    upppercase: "То {maxFileSize}",
    lowercase: "то {maxFileSize}",
  },
  maxUploadFilesAmountWithSize:
    "то {maxFilesAmount} файл, ҳар яке то {maxFileSize}",
  minMaxUploadFilesAmountWithSize:
    "аз {from} то {to} файл, на бештар аз {size} ҳар кадом",
  oneUploadFileWithMaxsize: "1 файл то {maxFileSize}",
  newFileAction: {
    moveOr: "Кашола кунед ё",
    upload: "файлҳоро бор кунед",
  },
  validation: {
    maxSize: "Андозаи максималии файл зиёд шуд",
    unsupportedFileType: "Формати файл дастгирӣ намешавад",
    addedUnsupportedFiles: "Файлҳои дастгиринашаванда илова шуданд",
    totalSizeNotMoreThan:
      "Ҳаҷми умумии файлҳо набояд аз {totalSize} зиёд бошад",
    exceedFilesAmountLimit: "Миқдори файлҳои боршаванда аз ҳад зиёд аст",
  },
  uploadPhoto: "Акс бор кунед",
  photoAspect: "Таносуби паҳлуҳои тасвир — {aspect}",
  pictureEditing: "Таҳрири тасвирҳо",
  selectedAreaWillDisplay:
    "Қисмати интихобшуда ҳангоми дидани муассисаи шумо дар RC PAY намоиш дода мешавад.",
};
